import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 350px;
            background-color: ${COLORS.background.base};
            border: 0.5px solid rgba(211, 211, 211, 0.5);
            padding: 5px;
            margin-bottom: 15px;
            border-top: 0;
        `,
    },
    headerProps: {
        css: css`
            > button {
                border: 0.5px solid rgba(211, 211, 211, 0.5) !important;
                opacity: 1;
                background-color: ${COLORS.background.base};
                padding: 5px;
                &:focus {
                    border-color: rgba(255, 255, 255, 0.5);
                    border-style: solid;
                    border-width: 0.5px;
                    outline: 0;
                    padding: 5px;
                    padding-left: 5px;
                    padding-top: 5px !important;
                }
                > span[class^="TypographyStyle"] {
                    opacity: 1;
                    color: ${getColor("secondary")};
                    font-family: ${TYPOGRAPHY.fontFamily.dosis};
                    font-size: ${TYPOGRAPHY.size.mbase};
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    font-style: normal;
                    letter-spacing: ${TYPOGRAPHY.letterSpacing.smallish};
                    text-align: left;
                    line-height: ${TYPOGRAPHY.lineHeight.base};
                    text-transform: uppercase;
                }
            }
            button[aria-expanded="false"] {
                margin-bottom: 15px;
            }
        `,
    },
    toggleIconProps: {
        css: css`
            opacity: 1;
            background-color: ${getColor("secondary")};
            border-radius: 50%;
            height: 15px;
            width: 15px;
            > svg {
                color: ${COLORS.white};
                opacity: 1;
                height: 15px;
                width: 15px;
            }
        `,
    },
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        > legend[class^="TypographyStyle"]:first-child {
            margin-bottom: 0;
        }
        > span[class^="TypographyStyle"]:last-child {
            margin-top: 5px;
        }
    `,
};

productListFilterAccordionSectionStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        span[role="checkbox"] {
            ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                          margin-top: 5px;
                      `
                    : css`
                          margin-top: 4px;
                      `}
            border-radius: 2px;
            border: 0.5px solid rgba(151, 151, 151, 1);
            opacity: 1;
            background-color: ${COLORS.white};
            height: 14px;
            width: 14px;
            min-width: 14px;
            &:focus {
                box-shadow: none;
            }
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
            opacity: 1;
            color: ${COLORS.black};
            font-family: ${TYPOGRAPHY.fontFamily.montserrat};
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.base};
            font-style: normal;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smallest};
            text-align: left;
        `,
    },
};

productListFilterAccordionSectionStyles.checkBoxSelected = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        span[role="checkbox"] {
            ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                          margin-top: 5px;
                      `
                    : css`
                          margin-top: 4px;
                      `}
            background: ${getColor("primary")} !important;
            height: 14px;
            width: 14px;
            min-width: 14px;
            &:focus {
                box-shadow: none;
            }
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
            opacity: 1;
            color: ${COLORS.black};
            font-family: ${TYPOGRAPHY.fontFamily.montserrat};
            font-size: ${TYPOGRAPHY.size.smaller};
            font-style: normal;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smallest};
            text-align: left;
            font-weight: ${TYPOGRAPHY.weight.base};
        `,
    },
};
